<template>
  <AdminModal :title="`Registrar pago · ${row.name}`" @close="$emit('close')">
    <form id="pay-form" @submit.prevent="submit">
      <p class="ad-note">
        Plan <strong>{{ row.plan }}</strong> · {{ money(row.effectiveAmount) }} al mes
        <template v-if="row.discountPercent"> (con {{ row.discountPercent }}% de descuento)</template>.
        Próximo cobro actual: <strong>{{ formatDate(row.nextBillingAt) }}</strong>.
      </p>
      <div class="grid">
        <div class="ad-field">
          <label for="pay-months">Meses que cubre</label>
          <select id="pay-months" v-model.number="form.months" class="ad-select" @change="onMonths">
            <option v-for="m in [1, 2, 3, 6, 12]" :key="m" :value="m">{{ m }} {{ m === 1 ? 'mes' : 'meses' }}</option>
          </select>
        </div>
        <div class="ad-field">
          <label for="pay-amount">Monto recibido (MXN)</label>
          <input id="pay-amount" v-model="form.amount" type="number" min="0.01" step="0.01" class="ad-input" required />
        </div>
        <div class="ad-field">
          <label for="pay-date">Fecha del pago</label>
          <input id="pay-date" v-model="form.paidAt" type="date" :max="today" class="ad-input" required />
        </div>
        <div class="ad-field">
          <label for="pay-method">Método</label>
          <select id="pay-method" v-model="form.method" class="ad-select">
            <option value="">Sin especificar</option>
            <option v-for="(label, key) in PAYMENT_METHODS" :key="key" :value="key">{{ label }}</option>
          </select>
        </div>
      </div>
      <div class="ad-field">
        <label for="pay-ref">Referencia (opcional)</label>
        <input id="pay-ref" v-model="form.reference" class="ad-input" maxlength="100" placeholder="Folio, clave de rastreo…" />
      </div>
      <div class="ad-field">
        <label for="pay-note">Nota (opcional)</label>
        <input id="pay-note" v-model="form.note" class="ad-input" maxlength="300" />
      </div>
      <p v-if="error" class="ad-error">{{ error }}</p>
    </form>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="submit" form="pay-form" class="ad-btn ad-btn--primary" :disabled="busy">{{ busy ? 'Guardando…' : 'Registrar pago' }}</button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref, reactive } from 'vue'
import AdminModal from './AdminModal.vue'
import { registerPayment } from '@/services/superadmin'
import { errorText, formatDate, money, todayInput, PAYMENT_METHODS } from './adminFormat'

const props = defineProps({ row: { type: Object, required: true } })
const emit = defineEmits(['close', 'done'])

const today = todayInput()
const form = reactive({
  months: 1,
  amount: props.row.effectiveAmount ?? '',
  paidAt: today,
  method: '',
  reference: '',
  note: '',
})
const busy = ref(false)
const error = ref('')

// Al cambiar los meses se recalcula el monto sugerido (se puede corregir a mano después).
function onMonths() {
  form.amount = Math.round((props.row.effectiveAmount * form.months + Number.EPSILON) * 100) / 100
}

async function submit() {
  busy.value = true
  error.value = ''
  try {
    const res = await registerPayment(props.row.id, { ...form, method: form.method || undefined })
    emit('done', res)
  } catch (err) {
    error.value = errorText(err)
  } finally {
    busy.value = false
  }
}
</script>

<style scoped>
.grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0 12px; }
@media (max-width: 480px) { .grid { grid-template-columns: 1fr; } }
</style>